import React from 'react';
import styles from './styles.module.css';

import ItemLink from '../../../components/item-link';

export default ({ relatedItems = [] }) => (
  <ul className={styles.container}>
    {relatedItems.map(id => (
      <li key={id}>
        <ItemLink
          id={id}
          imageSizes="(min-width: 1200px) 244px, (min-width: 768px) calc(25vw - 2.75rem), calc(50vw - 3rem)"
        />
      </li>
    ))}
  </ul>
);



// WEBPACK FOOTER //
// ./src/page-components/glass-detail/related/index.js